// Panel info
export const STAFF_HOME_PANEL_GET_INFO_REQUEST = 'STAFF_HOME_PANEL_GET_INFO_REQUEST';
export const STAFF_HOME_PANEL_GET_INFO_SUCCESS = 'STAFF_HOME_PANEL_GET_INFO_SUCCESS';
export const STAFF_HOME_PANEL_GET_INFO_FAILURE = 'STAFF_HOME_PANEL_GET_INFO_FAILURE';

export const FETCH_STAFF_DATA_DASHBOARD = 'FETCH_STAFF_DATA_DASHBOARD';

export const FETCH_STAFF_DATA_REVIEW_LIST_COUNT = 'FETCH_STAFF_DATA_REVIEW_LIST_COUNT';
